import React from 'react';
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import InvoiceForm from './InvoiceForm';
import { getParam } from '../../utils/utils'
import { fetchInvcs } from "../../actions/invcActions"
import { fetchOrders } from '../../actions/orderActions'

class InvoicePage extends React.Component {

  orderId = getParam('order_id');
  invcId = getParam('id');

  componentWillMount(){
    this.props.fetchInvcs(this.orderId);
    this.props.fetchOrders();
  }

  render() {
    if(
      isEmpty(this.props.orders)
      || isEmpty(this.props.requs)
      || isEmpty(this.props.invcs)
      || isEmpty(this.props.comprights)
    ){
      return(
        <div>Не загружены данные</div>
      );
    }
    const order = this.props.orders.find(el => el.order_id === parseInt(this.orderId,10));
    const invc = this.props.invcs[this.orderId].data.find(el => el.invc_id === parseInt(this.invcId,10));
    if(isEmpty(order)
      || isEmpty(invc)
    ){
      return(<div>Не загружены данные</div>);
    }
    if(!order.order_id){
      return (
        <div>Заказ не найден</div>
      );
    }
    return (
      <div>
        <InvoiceForm
          order={order}
          comprights={this.props.comprights}
          invc={invc}
          requs={this.props.requs}
          orderId={this.orderId}
          invcId={this.invcId}
        />
      </div>
    );
  }
}

function mapPostsToProps(store) {
  return {
    orders: store.orders.data,
    comprights: store.auth.comprights,
    invcs: store.invcs,
    requs: store.requs.data
  }
}

export default connect(mapPostsToProps, { fetchInvcs, fetchOrders })(InvoicePage);



// WEBPACK FOOTER //
// ./src/components/invoice/InvoicePage.js